import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PumpProducts.css';

const PumpProducts = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);

  const toggleCategory = (index) => {
    if (expandedCategory === index) {
      setExpandedCategory(null);
    } else {
      setExpandedCategory(index);
    }
  };

  const pumpCategories = [
    {
      title: "SUBMERSIBLE PUMPS",
      icon: "🌊",
      color: "#0066CC",
      description: "Stainless steel submersible pumps for boreholes and deep wells",
      image: "/images/products/submersible-pump.jpg",
      specs: [
        "4\" Submersible Pumps: 0.75kW to 3.7kW (1HP to 5HP)",
        "6\" Submersible Pumps: 5.5kW to 11kW (7.5HP to 15HP)",
        "Single Phase & Three Phase options",
        "Stainless steel AISI 304 construction",
        "Heads up to 220 meters",
        "Flows from 1.5 to 24 m³/hr"
      ],
      features: [
        "Built-in check valve",
        "Sand-resistant up to 50g/m³",
        "Thermal overload protection",
        "Water-filled motors",
        "IP68 protection rating",
        "Class F insulation"
      ],
      applications: "Borehole water supply, farm irrigation, community water projects, industrial water supply"
    },
    {
      title: "MONO BLOCK PUMPS",
      icon: "⚙️",
      color: "#1C1C1C",
      description: "Self-priming centrifugal pumps for domestic and agricultural use",
      image: "/images/products/monoblock-pump.jpg",
      specs: [
        "0.37kW to 3.7kW (0.5HP to 5HP)",
        "Single Phase & Three Phase options",
        "Heads up to 50 meters",
        "Flows from 1.2 to 7.8 m³/hr",
        "Suction lift up to 6 meters"
      ],
      features: [
        "Self-priming design",
        "Cast iron body with stainless steel shaft",
        "Copper windings",
        "Mechanical seal",
        "Thermal overload protection",
        "Class B/F insulation"
      ],
      applications: "Domestic water supply, garden irrigation, water transfer, pressure boosting"
    },
    {
      title: "CENTRIFUGAL PUMPS",
      icon: "🔄",
      color: "#0066CC",
      description: "High flow pumps for irrigation and industrial applications",
      image: "/images/products/centrifugal-pump.jpg",
      specs: [
        "1.5kW to 7.5kW (2HP to 10HP)",
        "Single Phase & Three Phase",
        "Heads up to 60 meters",
        "Flows from 8 to 55 m³/hr",
        "Inlet sizes: 2\" to 4\""
      ],
      features: [
        "End suction design",
        "Back pull-out construction",
        "Bronze/Grey iron impellers",
        "Mechanical seal",
        "Grease lubricated bearings",
        "Continuous duty rating"
      ],
      applications: "Irrigation schemes, water treatment plants, industrial water circulation, booster systems"
    },
    {
      title: "SOLAR PUMPS",
      icon: "☀️",
      color: "#1C1C1C",
      description: "DC solar-powered pumps for remote areas and off-grid applications",
      image: "/images/products/solar-pump.jpg",
      specs: [
        "0.75kW to 1.5kW (1HP to 2HP)",
        "DC 96V to 120V",
        "Submersible and surface models",
        "Heads up to 80 meters",
        "Flows from 2 to 12 m³/hr"
      ],
      features: [
        "Brushless DC motors",
        "MPPT compatible",
        "No batteries required",
        "Auto start/stop",
        "Dry run protection",
        "Soft start technology"
      ],
      applications: "Remote water supply, livestock watering, solar irrigation, off-grid communities"
    },
    {
      title: "OPEN WELL PUMPS",
      icon: "⛲",
      color: "#0066CC",
      description: "Pumps designed for open wells, reservoirs, and tanks",
      image: "/images/products/openwell-pump.jpg",
      specs: [
        "1.1kW to 2.2kW (1.5HP to 3HP)",
        "Single Phase & Three Phase",
        "Heads up to 28 meters",
        "Flows from 6 to 20 m³/hr",
        "Outlet sizes: 2\" to 2.5\""
      ],
      features: [
        "Open well design",
        "Foot valve included",
        "Stainless steel strainer",
        "Cast iron construction",
        "Bronze impeller options",
        "Easy installation"
      ],
      applications: "Open wells, reservoirs, water tanks, ponds, lakes"
    },
    {
      title: "PUMP MOTORS",
      icon: "⚡",
      color: "#1C1C1C",
      description: "Stainless steel submersible motors for pump replacement",
      image: "/images/products/pump-motor.jpg",
      specs: [
        "4\" Motors: 0.75kW to 2.2kW",
        "6\" Motors: 5.5kW to 7.5kW",
        "Single Phase & Three Phase",
        "Speed: 2850 RPM",
        "Water-filled or Oil-filled"
      ],
      features: [
        "Stainless steel AISI 304/316",
        "Ball bearing construction",
        "Class F/H insulation",
        "IP68 protection",
        "Built-in capacitor (single phase)",
        "Thermal protection"
      ],
      applications: "Replacement motors for submersible pumps, new pump installations"
    },
    {
      title: "CONTROL PANELS",
      icon: "📟",
      color: "#0066CC",
      description: "Intelligent pump controllers with protection features",
      image: "/images/products/control-panel.jpg",
      specs: [
        "Single Phase: Up to 1.5kW",
        "Three Phase: Up to 11kW",
        "DOL and Star-Delta starters",
        "Solar DC controllers available",
        "IP54 enclosure"
      ],
      features: [
        "Dry run protection",
        "Overload protection",
        "Phase failure protection",
        "Auto/Manual modes",
        "Digital display options",
        "Float switch inputs"
      ],
      applications: "Automatic pump control, protection systems, remote monitoring"
    },
    {
      title: "COLUMN PIPES & ACCESSORIES",
      icon: "🧴",
      color: "#1C1C1C",
      description: "UPVC rising mains and pump installation accessories",
      image: "/images/products/column-pipe.jpg",
      specs: [
        "Sizes: 1¼\", 1½\", 2\", 2½\", 3\"",
        "Length: 3 meters standard",
        "UPVC material",
        "Threaded connections",
        "Pressure rated"
      ],
      features: [
        "Lightweight yet strong",
        "Corrosion resistant",
        "Easy installation",
        "Threaded ends",
        "Couplings available",
        "Stainless steel clamps"
      ],
      applications: "Rising mains for submersible pumps, water transmission"
    }
  ];

  return (
    <div className="products-page pump-products-page">
      <div className="container">
        <h1 className="page-title">Versil Pumps & Motors</h1>
        <p className="page-subtitle">Connecting Water With You - Quality Pumps from Masai Store Ltd</p>
        
        <div className="intro-banner pump-banner">
          <div className="banner-content">
            <h2>Sole Importers & Distributors of Versil Pumps in Kenya</h2>
            <p>Complete water solutions - from borehole drilling to pump installation</p>
          </div>
        </div>
        
        <div className="products-showcase">
          {pumpCategories.map((category, index) => (
            <div key={index} className={`product-showcase-card ${expandedCategory === index ? 'expanded' : ''}`}>
              <div className="product-showcase-header" onClick={() => toggleCategory(index)}>
                <div className="product-icon" style={{ background: category.color }}>{category.icon}</div>
                <div className="product-header-info">
                  <h2>{category.title}</h2>
                  <p className="product-description">{category.description}</p>
                </div>
                <div className="expand-icon">
                  {expandedCategory === index ? '−' : '+'}
                </div>
              </div>
              
              {expandedCategory === index && (
                <div className="product-expanded-content">
                  <div className="product-specs">
                    <h3>Available Specifications</h3>
                    <ul>
                      {category.specs.map((spec, i) => (
                        <li key={i}>{spec}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="product-features">
                    <h3>Key Features</h3>
                    <ul>
                      {category.features.map((feature, i) => (
                        <li key={i}>✓ {feature}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="product-applications">
                    <h3>Applications</h3>
                    <p>{category.applications}</p>
                  </div>
                  
                  <div className="product-actions">
                    <Link to="/pump-catalogue" className="btn btn-primary">View Full Catalogue</Link>
                    <Link to="/contact" className="btn btn-secondary">Request Quote</Link>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="why-versil">
          <h2>Why Choose Versil Pumps?</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">🏭</div>
              <h3>Italian Technology</h3>
              <p>Versil pumps are manufactured with Italian design and technology</p>
            </div>
            <div className="feature">
              <div className="feature-icon">⚡</div>
              <h3>Energy Efficient</h3>
              <p>High efficiency motors reduce electricity costs</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🛡️</div>
              <h3>Stainless Steel</h3>
              <p>Premium AISI 304 stainless steel construction</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔧</div>
              <h3>Easy Maintenance</h3>
              <p>Service-friendly design with readily available spares</p>
            </div>
            <div className="feature">
              <div className="feature-icon">✓</div>
              <h3>1 Year Warranty</h3>
              <p>Comprehensive warranty on all pumps</p>
            </div>
            <div className="feature">
              <div className="feature-icon">📞</div>
              <h3>Local Support</h3>
              <p>Technical support and after-sales service in Kenya</p>
            </div>
          </div>
        </div>

        <div className="pump-services">
          <h2>Our Pump Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Borehole Installation</h3>
              <p>Complete borehole pump installation with submersible cables and rising mains</p>
            </div>
            <div className="service-card">
              <h3>Pump Repair & Maintenance</h3>
              <p>Expert repair and maintenance for all Versil pump models</p>
            </div>
            <div className="service-card">
              <h3>Solar Pumping Systems</h3>
              <p>Design and installation of solar-powered water systems</p>
            </div>
            <div className="service-card">
              <h3>Technical Consultation</h3>
              <p>Free technical advice on pump selection and system design</p>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <h2>Need Help Choosing the Right Pump?</h2>
          <p>Contact our technical team for expert advice on your water pumping needs</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
            <a href="tel:0700241467" className="btn btn-secondary">Call 0700 241467</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PumpProducts;